import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { theme } from "../../utils/global-styles/theme";

import PlayVideoIcon from "../shared/PlayVideoIcon";
import VideoOverlay from "../BecomeAFellow/child-components/VideoOverlay";

const VideoPreview = ({
  videoPreviewUrl,
  title,
  videoThumbnail,
  hasGrayBackground,
  caption,
  mobileTextSize,
  height,
}) => {
  const [videoOverlayActive, setVideoOverlayActive] = useState(false),
    handleVideoContainerClick = () => {
      videoOverlayActive
        ? setVideoOverlayActive(false)
        : setVideoOverlayActive(true);
    };

  const VideoPreviewContainer = styled.div`
      font-family: ${theme.fontFaces.headers};
      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        height: 300px;
      }

      @media only screen and (max-width: ${theme.breakpoints.mobile}) {
        height: 250px;
        iframe {
          height: 50%;
        }
      }
    `,
    ThumnbnailImageContainer = styled.div`
      height: ${height ? height : "350px"};
      display: grid;
      grid-template: 1fr / 1fr;

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        height: 100%;
        width: 100%;
      }
    `,
    ThumbNailImage = styled(GatsbyImage)`
      height: 100%;
      width: 100%;
      grid-area: 1 / 1 / span 1 / span 1;
      z-index: 1;
    `,
    ThumbNailPlaceholder = styled.div`
      height: 100%;
      width: 100%;
      grid-area: 1 / 1 / span 1 / span 1;
      z-index: 1;
    `,
    PreviewVideoTintContainer = styled.div`
      opacity: 0;
      grid-area: 1 / 1 / span 1 / span 1;
      z-index: 2;

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        height: 100%;
        width: 100%;
      }
    `,
    WatchVideoTextContainer = styled.div`
      grid-area: 1 / 1 / span 1 / span 1;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 3;
      cursor: pointer;
    `,
    WatchVideoPreviewText = styled.h2`
      font-size: 40px;
      font-weight: bold;
      letter-spacing: -1.04px;
      line-height: 48px;
      margin-left: 20px;
      z-index: 3;
      color: white;

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        font-size: ${mobileTextSize ? mobileTextSize : "32px"};
        font-weight: bold;
        letter-spacing: -0.83px;
        line-height: 38px;
        margin-left: 10px;
      }
    `;

  return (
    <VideoPreviewContainer
      className={hasGrayBackground ? "light-bg" : "white-bg"}
    >
      {videoOverlayActive ? (
        <VideoOverlay
          show={videoOverlayActive}
          closeVideoOverlay={handleVideoContainerClick}
          videoUrl={videoPreviewUrl}
          title={title}
        />
      ) : (
        <ThumnbnailImageContainer>
          {videoThumbnail && videoThumbnail.gatsbyImageData ? (
            <ThumbNailImage
              image={getImage(videoThumbnail?.gatsbyImageData)}
              alt={videoThumbnail.title}
            />
          ) : (
            <ThumbNailPlaceholder className="primary-bg"></ThumbNailPlaceholder>
          )}
          <PreviewVideoTintContainer className="secondary-bg" />
          <WatchVideoTextContainer onClick={() => handleVideoContainerClick()}>
            <PlayVideoIcon
              height="35px"
              width="35px"
              mobileHeight="30px"
              mobileWidth="30px"
              fillColorClassNames="white-svg"
            />
            <WatchVideoPreviewText>
              {caption || "Watch a Preview"}
            </WatchVideoPreviewText>
          </WatchVideoTextContainer>
        </ThumnbnailImageContainer>
      )}
    </VideoPreviewContainer>
  );
};

VideoPreview.propTypes = {
  videoPreviewUrl: PropTypes.string,
  title: PropTypes.string,
  videoThumbnail: PropTypes.shape({
    fluid: PropTypes.shape({
      srcSet: PropTypes.string,
    }),
    title: PropTypes.string,
  }),
  hasGrayBackground: PropTypes.string,
};

export default VideoPreview;
